import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import SkipLink from '../components/SkipLink';

/**
 * PublicLayout - Main layout wrapper for public pages
 * Includes header, main content area, and footer
 * Implements accessibility features: skip link, semantic landmarks
 */
const PublicLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Skip to main content link for keyboard users */}
      <SkipLink />

      <Header />

      {/* Main content area with landmark and focus target */}
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        role="main"
        aria-label="Main content"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          outline: 'none', // Remove focus outline since it's programmatic
          pt: 8, // Account for fixed header height (~64px)
        }}
      >
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
};

export default PublicLayout;
